import api from "./../utils/api";

export const addToCart = async (productId, packageId = null) => {
    try {
        const response = await api.post(
            `/cart/add`,
            {
                productId,
                packageId
            },
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCart = async () => {
    try {
        const response = await api.get(
            `/cart/get-cart`,
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteFromCart = async () => {
    try {
        const response = await api.delete(
            `/cart/delete`,
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const removeCartItem = async (productId, packageId = null) => {
    try {
        const response = await api.patch(
            `/cart/remove-item`,
            {
                productId,
                packageId
            },
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};
